import React from "react";
import styled, { keyframes } from "styled-components";
import { checkPixel } from 'utils';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $width }) => $width ? `width:${checkPixel($width)}` : '3.625rem'};
  ${({ $height }) => $height ? `height:${checkPixel($height)}` : '3.625rem'};
`;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
}`

const LoadingSpinner = styled.div`
  border: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  border-top-color: white;
  opacity: 1;
  position: relative;
  margin: auto;
  ${({ $width }) => $width ? `width:${checkPixel($width)}` : '3.625rem'};
  ${({ $height }) => $height ? `height:${checkPixel($height)}` : '3.625rem'};
  transition: opacity 200ms;
  animation: ${rotate} 1s linear;
  animation-iteration-count: infinite;
  transition-delay: '200ms'
`

export function Spinner({ className, ...props }) {
  return (
    <Container {...props}>
      <LoadingSpinner {...props}/>
    </Container>
  );
}